// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"398":"b8677a56","589":"b0ee5067","616":"b6b7794c","855":"b8677a56","926":"e2119528"}[chunkId] + ".chunk.css";
};